<template lang="pug">
  .delete-btn(
    @keyup.enter="$emit('delete')")
    v-dropdown(
      ref="dropdown"
      width-auto
      :disabled="disabled"
      :fixed-bottom="isMobile")
      slot
        v-btn(
          text
          danger
          :disabled="disabled")
          | {{ 'base.delete' | translate }}
      .delete-btn__content(
        ref="dropdownContent"
        slot="content")
        v-card(
          danger
          elevated)
          v-card-title
            .card-text.mb-3 {{ 'info.delete' | translate }}
          v-card-actions
            v-btn.mr-2(
              danger
              @click="$emit('delete')")
              | {{ 'base.delete' | translate }}
            v-btn(
              text
              @click="$refs.dropdown.closeDropdown()")
              | {{ 'base.cancel' | translate }}
</template>

<script>
import adaptationMixin from '@/mixins/adaptation.mixin'

export default {
  name: 'DeleteBtn',

  mixins: [adaptationMixin],

  props: {
    disabled: Boolean
  }
}
</script>

<style lang="scss" scoped>
.delete-btn {
  display: inline-flex;

  &__content {
    min-width: 32.5rem;
    width: 100%;
  }
}
</style>
